module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAALCAYAAABoKz2KAAAAAXNSR0IArs4c6QAAAKFJREFUOE+90zsKgkEMhdHvooi9WFrYuj0r3/hegBsSwU24Dyv9jQRGkMF0M6YN3ENCIgqXmY2AC3CStI7iVdI1sy5wAwYpdyVp88soCjuQJj4D/QQuJW1zvDgc4AtJu2+8Chzgc0n7D14NDvCZpIP3qsIBPpV0lJl1Sl52kDUErkAv9ScO34FWZfyVtuvv5tU4/ADaleE8/unw+A8T53DzBgrfNuIaNvSVAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/news/more_arrow_right.png
// module id = nBA9
// module chunks = 1